// native slider for pp2-carousel-native (replaces instant-core Swiper)
// Controlled snap behaviour to match Swiper: finger-follows during drag, then
// animates to the adjacent slide over a fixed duration (no native momentum fling).
(function(){
  var SPEED=300;            // ms, matches Swiper speed:300
  var LONG_RATIO=0.5;       // drag past half a slide -> advance
  var SHORT_MS=300;         // quick flick window
  var SHORT_PX=20;          // min px for a quick flick to count
  var TAP_PX=8;             // below this = tap (let the link through)

  function easeOutCubic(t){return 1-Math.pow(1-t,3);}

  function setup(root){
    if(root.dataset.hbpp2Init) return; root.dataset.hbpp2Init='1';
    var slider=root.querySelector('.hbpp2-slider');
    var slides=[].slice.call(root.querySelectorAll('.hbpp2-slider-slide'));
    var pag=root.querySelector('.hbpp2-slider-pagination');
    var prev=root.querySelector('.hbpp2-slider-button-prev');
    var next=root.querySelector('.hbpp2-slider-button-next');
    if(!slider||!slides.length) return;

    var bullets=[];
    if(pag){
      pag.innerHTML='';
      slides.forEach(function(s,i){
        var b=document.createElement('div');
        b.className='hbpp2-slider-pagination-bullet';
        b.addEventListener('click',function(){goTo(i);});
        pag.appendChild(b); bullets.push(b);
      });
    }

    function nearestIndex(){
      var best=0,bd=1e9;
      slides.forEach(function(s,i){var d=Math.abs(s.offsetLeft-slider.scrollLeft);if(d<bd){bd=d;best=i;}});
      return best;
    }
    function maxScroll(){return slider.scrollWidth-slider.clientWidth;}
    function paint(){
      var idx=nearestIndex();
      bullets.forEach(function(b,i){b.classList.toggle('hbpp2-slider-pagination-bullet-active',i===idx);});
    }

    var anim=null;
    function animateTo(target){
      if(anim){cancelAnimationFrame(anim);anim=null;}
      target=Math.max(0,Math.min(target,maxScroll()));
      var start=slider.scrollLeft, dist=target-start, t0=null;
      if(Math.abs(dist)<1){slider.scrollLeft=target;paint();return;}
      function frame(ts){
        if(t0===null)t0=ts;
        var p=Math.min((ts-t0)/SPEED,1);
        slider.scrollLeft=start+dist*easeOutCubic(p);
        paint();
        if(p<1){anim=requestAnimationFrame(frame);}else{anim=null;}
      }
      anim=requestAnimationFrame(frame);
    }
    function goTo(i){i=Math.max(0,Math.min(i,slides.length-1));animateTo(slides[i].offsetLeft);}

    if(next) next.addEventListener('click',function(e){e.preventDefault();goTo(nearestIndex()+1);});
    if(prev) prev.addEventListener('click',function(e){e.preventDefault();goTo(nearestIndex()-1);});

    // update bullets on any scroll that isn't our animation
    slider.addEventListener('scroll',function(){if(!anim)requestAnimationFrame(paint);},{passive:true});

    // --- unified drag (mouse + touch) with controlled snap on release ---
    var down=false,sx=0,sl=0,startIdx=0,t0=0,moved=0,dragged=false;
    slider.addEventListener('pointerdown',function(e){
      if(e.pointerType==='touch')return;if(e.pointerType==='mouse'&&e.button!==0)return;
      if(anim){cancelAnimationFrame(anim);anim=null;}
      down=true;dragged=false;moved=0;
      sx=e.clientX;sl=slider.scrollLeft;startIdx=nearestIndex();t0=e.timeStamp;
    });
    slider.addEventListener('pointermove',function(e){
      if(!down)return;
      var dx=e.clientX-sx; moved=Math.abs(dx);
      if(!dragged&&moved>TAP_PX){dragged=true;slider.classList.add('is-dragging');try{slider.setPointerCapture(e.pointerId);}catch(_){}}
      if(dragged){slider.scrollLeft=Math.max(0,Math.min(sl-dx,maxScroll()));paint();}
    });
    function release(e){
      if(!down)return; down=false;
      try{slider.releasePointerCapture(e.pointerId);}catch(_){}
      if(!dragged){return;} // tap -> let the link navigate
      slider.classList.remove('is-dragging');
      var dx=e.clientX-sx, dt=e.timeStamp-t0;
      var w=slides[Math.min(startIdx,slides.length-1)].getBoundingClientRect().width||1;
      var target=startIdx;
      var longSwipe=Math.abs(dx)>w*LONG_RATIO;
      var shortSwipe=dt<SHORT_MS&&Math.abs(dx)>SHORT_PX;
      if(longSwipe||shortSwipe){ target=startIdx+(dx<0?1:-1); }
      goTo(target);
      // suppress the click that follows a real drag (prevents accidental navigation)
      var kill=function(ev){ev.stopPropagation();ev.preventDefault();slider.removeEventListener('click',kill,true);};
      slider.addEventListener('click',kill,true);
      setTimeout(function(){slider.removeEventListener('click',kill,true);},50);
    }
    slider.addEventListener('pointerup',release);
    slider.addEventListener('pointercancel',function(e){if(down){down=false;slider.classList.remove('is-dragging');}});

    paint();
  }

  function init(){[].slice.call(document.querySelectorAll('.hbpp2carousel')).forEach(setup);}
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
